import _Promise from "babel-runtime/core-js/promise";
import sysConfig from "../config/sysConfig";
import baseConfig from "../config/baseConfig";
import dict from "../tools/dict";
import oppService from "./opp-service";
import storge from "../tools/storage";
import definecfg from "../config/defineConfig.js";
import date from "../tools/date";
import csdcService from "./csdc-service";
import bizcfg from "../config/bizConfig.js";

export default {
  getDisabledFields: function getDisabledFields(_this, bsno) {
    if (!bsno) {
      return false;
    }
    return sysConfig.$syscfg.K_Request("Y1001130", {
      B_SNO: bsno
    }, true).then(function (res) {
      if (res.Code == "0") {
        var tmpObj = res.Data[0];
        _this.oppBusiData.disabledFields = tmpObj && tmpObj.DISABLED_PARAM ? _.chain(tmpObj.DISABLED_PARAM.split(",")).map(function (v) {
          return _.trim(v);
        }).value() : [];
        return _this.oppBusiData.disabledFields;
      }
    });
  },

  isFieldDisabled: function isFieldDisabled(_this, field) {
    var disabledFields = _this.oppBusiData.disabledFields;
    if (!disabledFields || !disabledFields.length) {
      return false;
    }
    return disabledFields.includes(field);
  },
  initBiz: function initBiz(_this, busiCode, userType) {
    var params = {};

    var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};
    params = {
      custCode: customerInfo.CUST_CODE,
      busiCode: busiCode,
      userType: userType || customerInfo.userType,
      custFname: customerInfo.CUST_FNAME,
      idType: customerInfo.ID_TYPE,
      idCode: customerInfo.ID_CODE
    };
    if (_this.$store.state.apptSn && _this.$store.state.bSno) {
      return this.initBizData(_this, params, _this.$store.state.bSno);
    } else {
      return _Promise.resolve([]);
    }
  },
  initBizData: function initBizData(_this, params, bsno) {
    var reqList = [];
    if (bsno) {
      reqList.push(this.getBizData(_this, { B_SNO: bsno }));
    } else {
      if (params.custCode) {
        reqList.push(this.getBizData(_this, {
          BUSI_CODE: params.busiCode,
          CUST_CODE: params.custCode
        }));
      } else if (params.custFname && params.idType && params.idCode) {
        reqList.push(this.getBizData(_this, {
          BUSI_CODE: params.busiCode,
          CUST_FNAME: params.custFname,
          ID_TYPE: params.idType,
          ID_CODE: params.idCode
        }));
      } else {
        return _Promise.resolve([]);
      }
    }
    return _this.$syscfg.K_Request_ALL(reqList).then(function (res) {
      var bizData = res.length > 0 ? res[0] : null;

      if (bizData && bizData.Code != "0") {
        consoleLog("flow-service历史流水查询失败" + bizData.Code + bizData.Msg);
        throw bizData.Msg;
      }

      var dd = bizData.Data.filter(function (v) {
        return v.PROC_STATUS !== "15";
      });
      if (dd.length == 0) {
        consoleLog("flow-service历史流水查询为空");
        return;
      }
      var userType = params.userType;

      var channel = "13";
      dd = _.filter(dd, function (v) {
        return v.YZT_CHANNEL == channel && v.USER_TYPE == userType;
      });

      dd = _.sortBy(dd, function (item) {
        return -Date.parse(item.OPER_TIME.replace(/-/g, "/"));
      });

      if (dd.length == 0 && _this.$storage.getSession(_this.$definecfg.IS_DOUBLE_RECORD) == "1") return;

      if (dd.length == 0) throw "未获取到当前用户的正确历史流水";

      var bdata = dd[0];

      return [bdata];
    });
  },

  getBizData: function getBizData(_this, param) {
    return _this.$syscfg.K_Request("F0000036", param);
  },
  getPreData: function getPreData(_this, params) {
    return _Promise.resolve({ Data: [] });
  },
  getBusiStartOpenTime: function getBusiStartOpenTime(_this, bSno) {
    return _this.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "QS4000062",
      B_SNO: bSno
    }).then(function (res) {
      return res.Data && res.Data[0] && res.Data[0].START_OPEN_TIME;
    });
  },

  getSyncResult: function getSyncResult(param) {
    var paramObj = _.cloneDeep(param);
    if (paramObj.BUSI_CODE === "V0148") {
      paramObj.BUSI_CODE = "";
    }
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y1001105",
      B_SNO: paramObj.B_SNO,
      BUSI_CODE: paramObj.BUSI_CODE,
      TRANS_STEP: paramObj.TRANS_STEP,
      IS_SHOW_ALL: "1"
    }).then(function (res) {
      return _.get(res, "Data", []);
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/service/flow-service.js
// module id = 955
// module chunks = 2